export default __webpack_public_path__ + "static/media/img3.cfc515d8.png";